import { Route, Switch } from "react-router-dom";
import ImpostosListagemPage from "./Listagem/index";

function ImpostosPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/impostos"
        component={ImpostosListagemPage}
      />
    </Switch>
  );
}

export default ImpostosPages;
